<template>
    <div>
    <div class="table-responsive" v-loading="loading">
        <table class="table table-striped table-hover">
            <tbody>
            <tr>
                <th style="min-width:150px;"></th>
                <th>Lead Goals</th>
                <th>Leads</th>
                <th>Budget</th>
                <th>Spend</th>
                <th>Percentage</th>
                <th>CPL</th>
                <th>Billable amount</th>
                <th>Status</th>
                <th></th>
            </tr>
            <template v-for="period in periods">
                <ebudgets-01-period :data="period" @edit="(id) => editBilling(id)"></ebudgets-01-period>

                <template v-for="campaign in period.campaigns" v-if="period.is_open">
                    <ebudgets-02-campaign :data="campaign" @edit="(id) => editOrder(id)"></ebudgets-02-campaign>

                    <template v-for="singlemulti in campaign.singlemulti" v-if="campaign.is_open">
                        <ebudgets-03-singlemulti :data="singlemulti"></ebudgets-03-singlemulti>

                        <template v-for="product in singlemulti.products" v-if="singlemulti.is_open">
                            <ebudgets-04-product :data="product"></ebudgets-04-product>

                            <template v-for="experience in product.experiences" v-if="product.is_open">
                                <ebudgets-05-experience :data="experience"></ebudgets-05-experience>
                            </template>
                        </template>
                    </template>
                </template>
            </template>
            </tbody>
        </table>

        <div style="margin: 10px;">
            <a href="#" @click.prevent="togglePeriods">{{ this.periods_open ? 'Close' : 'Show all' }}</a>
        </div>
    </div>
        <billing
            :show="show_dialogs.billing"
            :data_id="show_dialogs.billing_period_id"
            @close="show_dialogs.billing = false; refresh()"
            ></billing>
        <budget-campaign
            :show="show_dialogs.order"
            :data_id="show_dialogs.order_id"
            @close="show_dialogs.order = false; show_dialogs.order_id = null; refresh()"
        ></budget-campaign>
    </div>
</template>

<script>
import Ebudgets01Period from "./ebudgets-01-period";
import Ebudgets02Campaign from "./ebudgets-02-campaign";
import Ebudgets04Product from "./ebudgets-04-product";
import Ebudgets05Experience from "./ebudgets-05-experience";
import BudgetCampaign from "../dialogs/budget-campaign";
import Billing from "../../../BudgetPeriod/vue/dialogs/billing";
import Ebudgets03Singlemulti from "./ebudgets-03-singlemulti";

export default {
    components: {
        Ebudgets03Singlemulti,
        Billing, BudgetCampaign, Ebudgets05Experience, Ebudgets04Product, Ebudgets02Campaign, Ebudgets01Period},
    props: [
        'employer_id',
        'refreshIndex'
    ],
    data() {
        return {
            'periods': {},
            'loading': true,
            periods_open: false,
            first_open: true,
            show_dialogs: {
                'billing': false,
                'billing_period_id': null,
                'order': false,
                'order_id': null
            },
        };
    },
    watch: {
        refreshIndex() {
            this.refresh();
        }
    },
    methods: {
        refresh() {
            this.loading = true;
            return axios.get(url(`admin/budget/${this.employer_id}/budgets/spend-data`), {
                params: {
                    showAll: this.periods_open ? 1 : 0
                }
                }).then(response => {
                    this.periods = response.data.periods;
                    if (this.first_open) {
                        this.periods[1].is_open = true;
                    }

                    this.loading = false;
                });
        },
        editBilling(id) {
            this.show_dialogs.billing_period_id = id;
            this.show_dialogs.billing = true;
        },
        editOrder(id) {
            this.show_dialogs.order_id = id;
            this.show_dialogs.order = true;
        },
        togglePeriods() {
            this.periods_open = !this.periods_open;
            this.refresh();
        }
    },
    created() {
        this.refresh();
    }
}
</script>

<style>
</style>
